// extracted by mini-css-extract-plugin
module.exports = {"jumbtron":"Jumbtron_jumbtron__2jTus","title":"Jumbtron_title__twY2J","subtitle":"Jumbtron_subtitle__mCAm8"};